import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../app/providers/useAuth';
import { Button } from '../../../shared/ui/Button';
import styles from './AuthErrorScreen.module.css';

// PARA-105, AC-E1: экран блокировки при 401 — без доступа к остальному UI,
// без попытки вызвать другие защищённые эндпоинты.
export function AuthErrorScreen(): JSX.Element {
  const { t } = useTranslation('auth');
  const { retry } = useAuth();

  return (
    <div className={styles.wrapper}>
      <p className={styles.message}>{t('error.title')}</p>
      <Button variant="primary" onClick={retry}>
        {t('error.retry')}
      </Button>
    </div>
  );
}
